
import { defineComponent, PropType } from 'vue'
import { type Repository } from '~/types/types'

export default defineComponent({
  name: 'SidebarPendingAdhocRepos',
  props: {
    repoWithPendingAdhocRuns: { type: Array as PropType<Repository[]>, required: true }
  },
  methods: {
    buildRoute(repo: Repository) {
      return `/${this.$providerMetaMap[repo.vcsProvider].shortcode}/${repo.ownerLogin}/${
        repo.name
      }/issues`
    }
  }
})
